import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { IMAGES } from "@/data/content";
import { Lock } from "@phosphor-icons/react";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin/dashboard", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin/dashboard", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  const inputClass =
    "w-full bg-transparent border-b border-[#6B7280] text-[#F6F4F0] py-3 px-1 placeholder:text-[#6B7280] focus:border-[#C8A96A] focus:outline-none transition-colors";

  return (
    <div className="min-h-screen bg-navy flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <img src={IMAGES.logo} alt="4PS Marketing" className="h-28 w-auto object-contain mx-auto mb-6" />
          <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.3em] text-gold mb-4">
            <Lock size={14} /> Team Access
          </div>
          <h1 className="font-heading font-light text-4xl text-[#F6F4F0]">4PS Portal</h1>
        </div>

        <form data-testid="login-form" onSubmit={submit} className="space-y-8 border border-[#F6F4F0]/10 bg-[#101f30] p-10">
          <div>
            <label className="text-xs uppercase tracking-[0.2em] text-[#6B7280] block mb-2">Email</label>
            <input data-testid="login-email" type="email" className={inputClass} value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@4psmarketing.com" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-[0.2em] text-[#6B7280] block mb-2">Password</label>
            <input data-testid="login-password" type="password" className={inputClass} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
          </div>
          {error && <p data-testid="login-error" className="text-red-400 text-sm">{error}</p>}
          <button
            data-testid="login-submit-btn"
            type="submit"
            disabled={loading}
            className="w-full text-xs uppercase tracking-[0.2em] py-4 bg-[#C8A96A] text-[#0D1B2A] hover:bg-[#F6F4F0] transition-colors font-medium disabled:opacity-60"
          >
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>

        <button onClick={() => navigate("/")} className="block mx-auto mt-8 text-xs uppercase tracking-[0.2em] text-[#6B7280] hover:text-gold transition-colors">
          ← Back to site
        </button>
      </div>
    </div>
  );
}
